"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var _text = require("../text");

var _core = require("@emotion/core");

var ClickableText = (0, _context.styledWithTheme)(_text.Text)(function (_ref) {
  var theme = _ref.theme;
  return {
    cursor: 'pointer',
    color: theme.selectors.color('primary'),
    ':hover': {
      color: theme.selectors.color('primaryDark')
    }
  };
});
ClickableText.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps);

var defaultTitleRenderer = function defaultTitleRenderer(_ref2) {
  var titleText = _ref2.titleText,
      toggle = _ref2.toggle;
  return (0, _core.jsx)(ClickableText, {
    onClick: toggle,
    fontSize: "T400"
  }, titleText);
};

exports.defaultTitleRenderer = defaultTitleRenderer;